import { render, staticRenderFns } from "./itinerary-total.vue?vue&type=template&id=72893574&scoped=true&"
import script from "./itinerary-total.vue?vue&type=script&lang=js&"
export * from "./itinerary-total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72893574",
  null
  
)

export default component.exports